'use client';

import { useAuth } from '@/hooks/useAuth';
import {
  fetchUserUsage,
  selectIsUsageLoading,
  selectLastFetched,
} from '@/lib/redux/slices/usageSlice';
import type { AppDispatch } from '@/lib/redux/store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const UsageInitializer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const lastFetched = useSelector(selectLastFetched);
  const isUsageLoading = useSelector(selectIsUsageLoading);
  const { isAuthenticated, unifiedUser } = useAuth();

  // Fetch personal usage when authenticated (only once)
  useEffect(() => {
    if (isAuthenticated && unifiedUser?.id && !lastFetched && !isUsageLoading) {
      dispatch(fetchUserUsage());
    }
  }, [isAuthenticated, unifiedUser?.id, lastFetched, isUsageLoading, dispatch]);

  return null;
};

export default UsageInitializer;
